"use client";

import { applyTheme } from "@cloudscape-design/components/theming";
import { forwardTheme } from "@/lib/theme/forwardTheme";

// Apply the Forward Iris theme once, at client-module evaluation (during hydration) rather than
// in an effect, so it lands before the first post-hydration paint. `@cloudscape-design/.../theming`
// is a client-only module, so this cannot run at SSR — see docs/design/forward-brand-system.md.
// (Pre-merge polish: precompute generateThemeStylesheet() to a build-time CSS file for zero FOUC.)
if (typeof document !== "undefined") {
  applyTheme({ theme: forwardTheme });
}

export function ThemeInit(): null {
  return null;
}
